import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { PureComponent } from 'react';
import Events from '../utils/events';
import throttle from '../utils/throttle';
import { canUseDOM, getScrollContainer, getScrollTop } from '../utils/dom';
import noop from '../utils/noop';

var Scroller = /*#__PURE__*/function (_PureComponent) {
  _inherits(Scroller, _PureComponent);

  var _super = _createSuper(Scroller);

  function Scroller() {
    var _this;

    _classCallCheck(this, Scroller);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.mounted = void 0;
    _this.scrollThrottled = _this.props.onScroll ? throttle(_this.props.onScroll, 250) : noop;

    _this.onScroll = function () {
      var onScroll = _this.props.onScroll;
      if (!_this.mounted) return;
      typeof onScroll === 'function' && _this.scrollThrottled(_this.scrollTop);
    };

    _this.bindEvent = function () {
      _this.scrollContainer && Events.on(_this.scrollContainer, 'scroll', _this.onScroll);
    };

    _this.unBindEvent = function () {
      _this.scrollContainer && Events.off(_this.scrollContainer, 'scroll', _this.onScroll);
    };

    return _this;
  }

  _createClass(Scroller, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.bindEvent();
      this.mounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var container = this.props.container;

      if (prevProps.container !== container) {
        this.bindEvent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unBindEvent();
      this.mounted = false;
    }
  }, {
    key: "scrollContainer",
    get: function get() {
      var container = this.props.container;
      return getScrollContainer(container);
    }
  }, {
    key: "scrollTop",
    get: function get() {
      return getScrollTop(this.scrollContainer);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children || null;
    }
  }]);

  return Scroller;
}(PureComponent);

Scroller.displayName = 'Scroller';
Scroller.defaultProps = {
  prefixCls: 'za-scroller',
  container: canUseDOM ? window : undefined
};
export { Scroller as default };